export default __webpack_public_path__ + "static/media/Image4.55472d81.png";